module.exports = __webpack_public_path__ + "img/28.2.TN.3ab0533e.png";